// src/components/Login/Login.js
import React, { useState } from "react";
import axios from "axios";
import './Login.css';

const PlayerLogin = ({ onLogin, serverIP}) => {
    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");

    const handleLogin = async () => {
        try {
            const response = await axios.post(`${serverIP}/v1/user/login`, {
                username: login,
                password: password
            });
                    

            if (!response.data.token) {
                throw new Error('Token not received');
            }

            /*localStorage.setItem('authToken', response.data.token);
            // Сохраняем team_id в куки с сроком действия 7 дней
            Cookies.set('team_id', response.data.teamID, { expires: 7 });
            */

            // Добавляем токен в заголовки по умолчанию
            axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;

            // Добавляем передачу данных администратора
            onLogin({
                is_admin: response.data.is_admin,
                teamID: response.data.teamID,
                token: response.data.token
            });
            


            //onLogin();               
                   
        } catch (error) {
            console.error('Ошибка входа игрока', error);
            
            setError(error.response?.data?.message || 'Неверные учетные данные');
        }

    };

    return (
        <main className="main__Log">
            <div className="asd12Ador-2fA1">
                {error && <div className="error-message">{error}</div>}
                <div className="input__logreg">
                    <label htmlFor="player-login">Никнейм</label>
                    <input
                        type="text"
                        id="player-login"
                        placeholder="Введите никнейм"
                        required
                        value={login}
                        onChange={(e) => setLogin(e.target.value)}
                    />
                </div>
                <div className="input__logreg">
                    <label htmlFor="player-password">Пароль</label>
                    <div className="password__input">
                        <input
                            type={showPassword ? "text" : "password"}
                            id="player-password"
                            placeholder="Введите пароль"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <button
                            type="button"
                            className="show-password-btn"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? (
                                <img src="/Media/images/icons/log/EyeSlash.svg" alt="Скрыть пароль" />
                            ) : (
                                <img src="/Media/images/icons/log/hide.svg" alt="Показать пароль" />
                            )}
                        </button>
                    </div>
                </div>
                <button onClick={handleLogin} className="login__button">Войти</button>
            </div>
        </main>
    );
};

function Logreg({ onLogin, serverIP }) {
   /*const navigate = useNavigate();

    const handleLogin = () => {
        console.log('Navigating to /home...');
        navigate("/home");
    };*/

    return (
        <div className="container log">
            <img src="/Media/images/icons/log/logo_TG.png" alt="" className="logo" />
            <h2>Вход для игрока</h2>
            <PlayerLogin 
            onLogin={ onLogin } 
            serverIP={serverIP} 
            />
        </div>
    );
}

export default Logreg;
